var map = {
	"./add-user.svg": "2837",
	"./align-bottom.svg": "75db",
	"./align-left.svg": "d4aa",
	"./align-right.svg": "7526",
	"./align-top.svg": "5025",
	"./arrow-back.svg": "b8a8",
	"./arrow-d.svg": "14c0",
	"./arrow-l.svg": "2760",
	"./arrow-r.svg": "41c6",
	"./arrow-u.svg": "e22f",
	"./back.svg": "7338",
	"./boards.svg": "ac56",
	"./bookmark.svg": "7253",
	"./burger.svg": "ada2",
	"./calendar.svg": "b8bd",
	"./center-scene.svg": "f289",
	"./check-small.svg": "7677",
	"./clock.svg": "755b",
	"./close-small.svg": "a970",
	"./close.svg": "8b1b",
	"./collapse.svg": "dbb3",
	"./comment-solid.svg": "3642",
	"./comment.svg": "c47d",
	"./copy-text.svg": "37e4",
	"./copy.svg": "8aac",
	"./dark-theme.svg": "3eeb",
	"./delete.svg": "0d45",
	"./dots-g.svg": "3964",
	"./dots.svg": "93d2",
	"./download.svg": "f28e",
	"./dropdown.svg": "6d05",
	"./embed.svg": "d5d0",
	"./expand.svg": "8336",
	"./favorites.svg": "cc00",
	"./forward.svg": "bdb1",
	"./frame.svg": "4fcc",
	"./group.svg": "51a3",
	"./home.svg": "ac9d",
	"./href.svg": "14b0",
	"./ideas.svg": "5d33",
	"./light-theme.svg": "a388",
	"./list-view.svg": "9783",
	"./lock.svg": "9619",
	"./logout.svg": "69e3",
	"./mention-off.svg": "522d",
	"./mention.svg": "6d35",
	"./mic-off.svg": "17cd",
	"./mic.svg": "6366",
	"./minus.svg": "3e24",
	"./moving.svg": "7dce",
	"./new-tab.svg": "ef08",
	"./notify.svg": "c760",
	"./ok-small.svg": "e321",
	"./ok.svg": "fecb",
	"./page.svg": "741b",
	"./pen.svg": "6492",
	"./phone-off.svg": "d81e",
	"./pin.svg": "862b",
	"./plus-small.svg": "9a68",
	"./plus.svg": "eb38",
	"./premium.svg": "8f2e",
	"./public.svg": "79b4",
	"./publish.svg": "0aba",
	"./refresh.svg": "53fa",
	"./restore.svg": "2a09",
	"./search.svg": "d103",
	"./send.svg": "5b6e",
	"./settings-small.svg": "ef39",
	"./settings.svg": "9174",
	"./sharing.svg": "fe55",
	"./star-filled.svg": "3d1d",
	"./star.svg": "cc90",
	"./start-presentation.svg": "6346",
	"./tidy-g.svg": "0697",
	"./tidy-v.svg": "d576",
	"./tile-view.svg": "becb",
	"./timer.svg": "291e",
	"./tool-card.svg": "8197",
	"./tool-checklist.svg": "10ce",
	"./tool-circle.svg": "5c65",
	"./tool-comment.svg": "8ee4",
	"./tool-data-base.svg": "c327",
	"./tool-diamond.svg": "5d9c",
	"./tool-doc.svg": "44d0",
	"./tool-ellipse.svg": "a7b5",
	"./tool-graffiti.svg": "44c2",
	"./tool-list.svg": "93a5",
	"./tool-parallelogram-right.svg": "8bb7",
	"./tool-parallelogram.svg": "a566",
	"./tool-square.svg": "d99e",
	"./tool-star.svg": "7c2a",
	"./tool-trapezoid.svg": "76de",
	"./tool-triangle-bottom.svg": "c6d5",
	"./tool-triangle-left.svg": "ed60",
	"./tool-triangle-right.svg": "c242",
	"./tool-triangle-top.svg": "b328",
	"./tool-upload.svg": "881d",
	"./transcribe.svg": "d5d4",
	"./turn-off.svg": "e08b",
	"./view-off.svg": "88e7",
	"./view.svg": "00ed",
	"./voice.svg": "f313",
	"./w-title.svg": "58c7"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "6f32";